
<footer class="footer">
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-6">
        Trendmulti &copy; {{ currentYear }}
      </div>
      <div class="col-md-6">
        <div class="text-md-end footer-links d-none d-md-block">
          <a [href]="statusPageUrl" target="_blank" rel="noopener">{{ 'layout.footer.statusPage' | translate }}</a>
          <a href="javascript:void(0);" (click)="goToKnowledgeBase()">{{ 'layout.footer.knowledgeBase' | translate }}</a>
          <a [href]="supportUrl" target="_blank" rel="noopener">{{ 'layout.footer.support' | translate }}</a>
          <a href="javascript:void(0);" (click)="openAboutModal()"><strong>v2.22.5</strong></a>
        </div>
      </div>
    </div>
  </div>
</footer>
